import { IconProps } from '../../types/icon';
import { Svg } from '../style';

export default function SystemCheck({ width = 16, height = 16, fill = 'white' }: IconProps) {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.99965 16.17L5.52965 12.7C5.13965 12.31 4.50965 12.31 4.11965 12.7C3.72965 13.09 3.72965 13.72 4.11965 14.11L8.29965 18.29C8.68965 18.68 9.31965 18.68 9.70965 18.29L20.2896 7.71001C20.6796 7.32001 20.6796 6.69001 20.2896 6.30001C19.8996 5.91001 19.2696 5.91001 18.8796 6.30001L8.99965 16.17Z"
        fill={fill}
      />
    </Svg>
  );
}
